import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Routes, Route } from "react-router-dom";
import { ROUTE_PATHS } from "@/lib/index";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Timeline from "@/pages/Timeline";
import Applications from "@/pages/Applications";
import Bahrain from "@/pages/Bahrain";
import Future from "@/pages/Future";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 1,
    },
  },
});

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner position="top-right" closeButton />
      <HashRouter>
        <Layout>
          <Routes>
            <Route 
              path={ROUTE_PATHS.HOME} 
              element={<Home />} 
            />
            <Route 
              path={ROUTE_PATHS.TIMELINE} 
              element={<Timeline />} 
            />
            <Route 
              path={ROUTE_PATHS.APPLICATIONS} 
              element={<Applications />} 
            />
            <Route 
              path={ROUTE_PATHS.BAHRAIN} 
              element={<Bahrain />} 
            />
            <Route 
              path={ROUTE_PATHS.FUTURE} 
              element={<Future />} 
            />
            {/* Fallback route - directs back to home for any undefined paths */}
            <Route 
              path="*" 
              element={<Home />} 
            />
          </Routes>
        </Layout>
      </HashRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
